module.exports = __webpack_public_path__ + "static/media/feature-interview-reminder.1500c3a4.png";